import administrationDashboardMoreComments from "~/store/graphql/queries/administrationDashboardMoreProcessedComments.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadAdminstrationMoreProcessedComments = async function (
  { commit },
  { params, req, res }
) {
  const data = await runGraphQLQuery(
    administrationDashboardMoreComments,
    params,
    this.$axios,
    req,
    res
  );

  commit("SET_ADMINISTRATION_MORE_PROCESSED_COMMENTS", data);

  return Promise.resolve(data);
};

export default loadAdminstrationMoreProcessedComments;
